<template>
  <div
    ref="listMenu"
    class="ah-nav-tabs"
  >
    <div
      ref="tabList"
      class="ah-nav-tabs__list"
      role="tablist"
      aria-orientation="vertical"
      :aria-labelledby="ariaLabelledby"
    >
      <AhMenuItem
        v-for="(item, itemIndex) in listItemsNewIndexs"
        :id="'tab__'+item.id"
        :key="itemIndex"
        :role="item.url ? null : 'tab'"
        :class="{'active-tab': activeTab === itemIndex}"
        :aria-controls="item.url ? undefined : 'tabs__'+item.id+'--'+itemIndex"
        :aria-selected="activeTab === itemIndex ? 'true' : 'false'"
        :tracking="item.tracking"
        :target="item.url && item.target"
        :label="item.text"
        :url="item.url || null"
        :tabindex="activeTab === itemIndex ? null : '-1'"
        variation="tab"
        @keydown.native="ArrowDownHandler"
        @clicked="activeTabPanel(item.newIndex, itemIndex, 'tabs__'+item.id)"
      />
    </div>
    <AhMegaMenu
      v-for="(item, itemIndex) in itemListPanels"
      :id="'tabs__'+item.id"
      ref="panelList"
      :key="itemIndex"
      tabindex="-1"
      :aria-labeledby="'tab__'+item.id"
      :hidden="activePanel !== itemIndex"
      :class="{'ah-mega-menu__shown': (activePanel === itemIndex)}"
      :visible="activePanel === itemIndex"
      :tracking="item.tracking"
      :list-items="item.panels"
      :list-push-items="item.pushs"
      transition-name="ah-fade"
      :show-tab-bar="false"
      @pushClicked="pushClickHandler"
      @megaMenu:itemClicked="clickHandler"
      @keydown.tab.native="accessibilityPanelHandler($event, 'tabs__'+item.id)"
    />
  </div>
</template>
<script>
  import AhMegaMenu from '../AhMegaMenu/AhMegaMenu.vue';
  import AhMenuItem from '../../molecules/AhMenuItem/AhMenuItem.vue';
  export default {
    name: 'AhNavTabs',
    components: {
      AhMenuItem,
      AhMegaMenu
    },
    props: {
      listItems: {
        default: () => [],
        type: Array
      },
      defaultIndex: {
        type: Number,
        default: 0,
        required: false,
      },
      ariaLabelledby: {
        type: String,
        default: 'more',
      },
    },
    data () {
      return {
        activeTabFocus: null,
        activePanel: null,
        activeTab: 0,
      };
    },
    computed: {
      tabCount() {
        const tabs = Array.prototype.slice.call(this.$refs.tabList.children || []);
        return tabs.length;
      },
      listItemsNewIndexs() {
        let found = 0;
        return this.listItems.map((currElement, index) => {
          if(!currElement.url) {
            if(!found) currElement.newIndex = index;
            else currElement.newIndex = index - found;
          }else {
            found++;
          }
          return currElement;
        });
      },
      isOnLastTab() {
        return this.activeTabFocus === this.tabCount - 1;
      },
      isOnFirstTab() {
        return this.activeTabFocus === 0;
      },
      itemListPanels() {
        return this.listItems.filter(item => typeof item.url === 'undefined');
      },
      hasPanel() {
        return typeof this.listItems[this.activeTabFocus].url === 'undefined';
      },
      firstItemIsTab() {
        return Object.keys(this.listItemsNewIndexs).length && Object.prototype.hasOwnProperty.call(this.listItemsNewIndexs[0], 'newIndex');
      }
    },
    watch: {
      activeTabFocus(ActivedTabFocus) {
        this.$refs.tabList.children[ActivedTabFocus].focus();
      },
    },
    mounted() {
      this.activeTabFocus = this.defaultIndex;
      if(this.firstItemIsTab) {
        this.activePanel = this.defaultIndex;
      }
    },
    methods: {
      activeTabPanel(panelIndex, tabIndex, tabId) {
        this.activePanel = panelIndex;
        this.activeTabFocus = tabIndex;
        this.activeTab = tabIndex;

        this.$nextTick(() => {
          if(this.hasPanel) {
            const panelFocusableElement = this.getFocusableElements(document.getElementById(tabId));
            panelFocusableElement[0].focus();
          }
        });
        this.EventsEmiter(
          {
            'more': true,
            'id': this.listItems[tabIndex].id,
            'text': this.listItems[tabIndex].text,
            'tracking': this.listItems[tabIndex].tracking
          }
        );
      },
      clickHandler(category) {
        this.EventsEmiter(
          {
            'id': category.id,
            'more': true,
            'text': category.text,
            'tracking': category.tracking,
            'parent': {
              'id': this.listItems[this.activePanel].id,
              'text': this.listItems[this.activePanel].text,
              'tracking': this.listItems[this.activePanel].tracking
            },
          }
        );
      },
      pushClickHandler(data) {
        this.EventsEmiter(
          {
            ...data,
            more: true,
            'parent': {
              'id': this.listItems[this.activePanel].id,
              'text': this.listItems[this.activePanel].text,
              'tracking': this.listItems[this.activePanel].tracking
            },
          }
        );
      },
      EventsEmiter(data) {
        this.$emit('tabs-nav-item-click', data);
      },
      getFocusableElements(elt) {
        const focusableElements =
          'a[href], button:not([disabled])';
        return elt.querySelectorAll(focusableElements);
      },
      accessibilityPanelHandler(e, tabId) {
        if (e.key && e.key === 'Tab' && !e.shiftKey) {
          const target = e.target;
          const panelFocusableElement = this.getFocusableElements(document.getElementById(tabId));
          if(target === panelFocusableElement[panelFocusableElement.length - 1] && (this.$refs.tabList.children.length -1 !== this.activeTabFocus)){
            this.activeTabFocus ++;
            e.stopPropagation();
            e.preventDefault();
          }
        }
      },
      ArrowDownHandler(e) {
        let flag = false;
        if (e.key && (e.key === 'ArrowDown' || e.key === 'ArrowRight')) {
          if(this.isOnLastTab) {
            this.activeTabFocus = 0;
          }
          else {
            this.activeTabFocus++;
          }
          if(e.shiftKey) {
            this.activeTabFocus = this.tabCount - 1;
          }
          flag = true;
        }
        if (e.key && (e.key === 'ArrowUp' || e.key === 'ArrowLeft')) {
          if(this.isOnFirstTab){
            this.activeTabFocus = this.tabCount - 1;
          } else {
            this.activeTabFocus--;
          }
          if(e.shiftKey) {
            this.activeTabFocus = 0;
          }
          flag = true;
        }
        if (e.key && e.key === 'Tab' && !e.shiftKey) {
          this.activeTabFocus = this.activeTab;
        }

        if(flag) {
          e.stopPropagation();
          e.preventDefault();
        }
      },
    }
  };
</script>
